import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import useLocalization from "../../hooks/useLocalization";
import usePage from "../../hooks/usePage";

import { Box, Stack, Button } from "@mui/material";

import Page from "./Page";
import Card from "../layout/Card";
import FileUpload from "../elements/FileUpload";

const ClientImports = () => {
  const { getTitle } = useLocalization();
  const location = useLocation();
  const navigate = useNavigate();
  const { showMessage } = usePage();

  const [currentImport, setCurrentImport] = useState(null);

  const currentUserId = useSelector((state) => state.authentication.userId);
  const email = useSelector((state) => state.authentication.email);
  const entityName = location.state.entityName;
  const entityId = location.state.entityId;
  const name = location.state.name;

  const handleImportSelection = (selection) => {
    setCurrentImport(selection);
  };

  const handleUploaded = () => {
    showMessage("You will receive an email on completion.");
  };

  const handleToolbarClick = (action) => {
    switch (action) {
      case "back":
        navigate("/client", { state: { clientId: entityId } });
        break;
    }
  };

  return (
    <Page
      pageName="Client Imports"
      entityName={name}
      includeToolbar={true}
      items={[
        {
          name: "back",
          iconName: "ArrowCircleLeft",
        },
      ]}
      onToolItemClick={handleToolbarClick}
    >
      <Box
        sx={{ display: "flex" }}
        gap={1}
      >
        <Card
          title={getTitle("imports")}
          sx={{ width: "300px" }}
        >
          <Stack>
            <Box>
              <Button
                onClick={() => handleImportSelection("importSkusForClient")}
              >
                {getTitle("importSkusForClient")}
              </Button>
            </Box>
            <Box>
              <Button onClick={() => handleImportSelection("importSkuPricing")}>
                Import SKU Pricing
              </Button>
            </Box>
            <Box>
              <Button onClick={() => handleImportSelection("importListings")}>
                Import SKU Listings
              </Button>
            </Box>
          </Stack>
        </Card>

        {currentImport !== null && (
          <Card
            title={getTitle(currentImport)}
            sx={{ width: "300px" }}
          >
            <Box padding="10px">
              <FileUpload
                entityName={entityName}
                entityId={entityId}
                data={{
                  workType: currentImport,
                  entityName: entityName,
                  entityId: entityId,
                  userId: currentUserId,
                  email: email,
                }}
                onUploaded={handleUploaded}
              />
            </Box>
          </Card>
        )}
      </Box>
    </Page>
  );
};

export default ClientImports;
